
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LandingHeader from "@/components/landing/LandingHeader";
import LandingForm from "@/components/landing/LandingForm";

const LandingPage = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  // Check for existing access data on component mount
  useEffect(() => {
    const accessData = localStorage.getItem('appAccess');
    if (accessData) {
      try {
        const parsedData = JSON.parse(accessData);
        if (parsedData.firstName && parsedData.lastName && parsedData.email && parsedData.country) {
          navigate('/home', { replace: true });
          return;
        }
      } catch {
        // invalid data, show form
      }
    }
    setChecking(false);
  }, [navigate]);

  const handleAccessGranted = () => {
    navigate('/home');
  };

  // Don't flash the login form while we check localStorage
  if (checking) return null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md space-y-8 bg-white p-8 rounded-lg shadow-md">
        <LandingHeader />
        <LandingForm onAccessGranted={handleAccessGranted} />
      </div>
    </div>
  );
};

export default LandingPage;
